module.exports = __webpack_public_path__ + "static/media/step-3-colored.0a3487f3.png";